// src/pages/Home.jsx
import React from 'react';
// composants
import Title from '../components/Title/Title';
import Content from '../components/content/content';
import Projects from '../components/Projects/project.jsx';
import Button from '../components/buttons/button';
// contenus
import parcours from '../assets/content/parcours.json';
import realisation from '../assets/content/realisations.json';
// import ContentSlider from '../components/content/content-slider.jsx';


const Home = () => {
  
  return (
    <>
      {/* Bloc Parcours */}
      <div className="parcours bloc">
        <Title title={parcours.title} variant={parcours.home.variant}></Title>
        <Content content={parcours.home.content} 
          image={{thumb: parcours.home.image,hd: parcours.home.imagegrd}}
          alt={parcours.home.alt} 
          cote={"left"}
          width={parcours.home.width} 
          height={parcours.home.height}
          >
            
        </Content>
        <Button text="En savoir plus" link ="/mon-parcours" cote="center"></Button>
      </div>
      
      {/* Bloc Réalisation */}
      <div className="realisations bloc">
        <Title title={realisation.title} variant={realisation.home.variant}></Title>
        <div className={`realisations-grid ${realisation.home.variant}`}>
          {realisation.realisations
            .filter(item => item.home === true)
            .map((item, index) => {
              
              return (
                <Projects
                  key={index}
                  image={item.image}
                  alt={item.alt}
                  nom_real={item.title}
                  description={item.description}
                  link={item.link}
                />
              );
            })}
        </div>
        
        <div className='button-container'>
          <Button text="Voir les réalisations" link ="/realisations"></Button>
        </div>
      </div>
    </>
  );
};

export default Home;